import { createReducer } from '@reduxjs/toolkit'
import { SavePaymentData } from '../actions/Payment-Actions'

const initialState = null

export const PaymentDataReducer = createReducer(initialState, (builder) => {
  builder.addCase(SavePaymentData, (state, action) => {
    // console.log(action, state)
    return action.payload
  })
})
